<template>
    <div class="c-m-rating__wrapper">
        <div class="c-m-rating">
            <avatar
                class="c-m-rating__avatar"
                :signature="ratingSignature"
            ></avatar>
            <div class="c-m-rating__bubble" :class="{'c-m-rating__bubble-max-height' : maxHeight}">
                <router-link class="c-m-rating__company" :to="link">
                    
                    <h3 v-if="companyName" class="c-m-rating__company">{{ companyName }}</h3>

                </router-link>
                <rating-atom class="c-m-rating__stars" :ratingValue="ratingVal"></rating-atom>
                <h3 v-if="ratingTitle" class="c-m-rating__title">{{ ratingTitle }}</h3>
                <p class="c-m-rating__body">{{ ratingComment }}</p>
                <p v-if="ratingSignature" class="c-m-rating__author">– {{ratingSignature}} <i>{{ratingDate}}</i></p>
            </div>
        </div>
        <div v-if="ratingAnswer" class="c-m-rating c-m-rating--answer">
            <avatar
                class="c-m-rating__avatar"
                :logo="companyLogo"
                :icon="'location_city'"
                :signature="company.Name"
            ></avatar>
            <div class="c-m-rating__bubble">
                <h3 class="c-m-rating__title">Hantverkarens svar</h3>
                <p class="c-m-rating__body">{{ ratingAnswer }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import filters from '../../../filters/index.js';
    import RatingAtom from '../atoms/AtomRating.vue';
    import Icon from '../atoms/AtomIcon.vue';
    import Avatar from '../atoms/AtomAvatar.vue';

      export default {
        filters: filters,
        props: [
            'rating',
            'company',
            'iconModifier',
            'maxHeight'
        ],
        components: {
            RatingAtom,
            Icon,
            Avatar
        },
        computed: {
            ratingTitle: function() {
                return this.rating.Title
            },
            ratingComment: function() {
                return this.rating.Comment
            },
            ratingSignature: function() {
                return this.rating.Signature ? filters.stripInitialSpecialChar(this.rating.Signature) : this.rating.SignCust ? filters.stripInitialSpecialChar(this.rating.SignCust) : ''
            },
            ratingVal: function() {
                return this.rating.Rating ? this.rating.Rating : this.rating.RatingValue ? this.rating.RatingValue : null
            },
            ratingAnswer: function() {
                return this.rating.Answer
            },
            ratingDate: function() {
                let date = this.rating.Date;
                
                if(!date){
                    date = this.rating.RateDate;
                }

                if(date){
                    date = this.$options.filters.formatDateWithoutTime(date);
                }

                return `(${date})` || '';
            },
            link: function(){
                return '/hantverkare/' + this.rating.CompanyId + '/';
            },
            companyName: function(){
                return this.rating.CompanyName ? this.rating.CompanyName : '';
            },
            companyLogo: function() {
                return this.company.Logo ? { src: this.company.Logo, alt: `Logotyp för ${this.company.Name}` } : null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeRating.vue